// past tense verbs describing the action
export const enum Action {
	Cancelled = 'cancelled',
	Clicked = 'clicked',
	Submitted = 'submitted',
	Closed = 'closed',
	Typed = 'typed',
	Searched = 'searched',
	Created = 'created',
	Updated = 'updated',
	Deleted = 'deleted',
	Invited = 'invited',
	Selected = 'selected',
	Focused = 'focused',
	Blurred = 'blurred',
	Viewed = 'viewed',
	Shown = 'shown',
	Displayed = 'displayed',
	Hidden = 'hidden',
	Hovered = 'hovered',
	Entered = 'entered',
	Switched = 'switched',
	Dwelled = 'dwelled',
	Toggled = 'toggled',
	Pressed = 'pressed',
	Pasted = 'pasted',
	Copy = 'copy',
	Changed = 'changed',
	Fetch = 'fetch',
	Fetched = 'fetched',
	Cleared = 'cleared',
	Opened = 'opened',
	Scrolled = 'scrolled',
	Moved = 'moved',
}

export const enum TrackAction {
	Clicked = 'clicked',
	Canceled = 'canceled',
	BackClicked = 'backClicked',
	Closed = 'closed',
	ConnectionFailed = 'connectionFailed',
	ConnectionSuccess = 'connectionSuccess',
	Created = 'created',
	CreationFailed = 'creationFailed',
	Edited = 'edited',
	EditFailed = 'editFailed',
	Updated = 'updated',
	Activated = 'activated',
	Linked = 'linked',
	DefaultGroupUpdated = 'defaultGroupUpdated',
	Added = 'added',
	Deactivated = 'deactivated',
	Deleted = 'deleted',
	Dismissed = 'dismissed',
	SetTrait = 'setTrait',
	Duplicated = 'duplicated',
	CanceledDeletion = 'canceledDeletion',
	Changed = 'changed',
	ChangeFailed = 'changeFailed',
	Submitted = 'submitted',
	Approved = 'approved',
	Denied = 'denied',
	Invited = 'invited',
	InvitedGuest = 'invitedGuest',
	Reset = 'reset',
	Resent = 'resent',
	ResumeDismissed = 'resumeDismissed',
	Impersonated = 'impersonated',
	Imported = 'imported',
	KeyRegenerated = 'keyRegenerated',
	Regenerated = 'regenerated',
	ChangedProductAccess = 'changedProductAccess',
	Toggled = 'toggled',
	Granted = 'granted',
	GrantedProductAccess = 'grantedProductAccess',
	Revoked = 'revoked',
	RevokedProductAccess = 'revokedProductAccess',
	Saved = 'saved',
	Sent = 'sent',
	AddedToGroup = 'addedToGroup',
	AddedUsers = 'addedUsers',
	Exposed = 'exposed',
	Downloaded = 'downloaded',
	Migrated = 'migrated',
	BulkMigrated = 'bulkMigrated',
	BulkSelectionLimit = 'bulkSelectionLimit',
	BulkDeleted = 'bulkDeleted',
	Verified = 'verified',
	Claimed = 'claimed',
	Unclaimed = 'unclaimed',
	Mismatched = 'mismatched',
	Connected = 'connected',
	Selected = 'selected',
	SyncStarted = 'syncStarted',
	SyncFinished = 'syncFinished',
	Synced = 'synced',
	GroupsUpdated = 'groupsUpdated',
	Disconnected = 'disconnected',
	Enabled = 'enabled',
	Disabled = 'disabled',
	SettingsUpdated = 'settingsUpdated',
	Exported = 'exported',
	ExportFailed = 'exportFailed',
	ClonedData = 'clonedData',
	ClonedSelectiveData = 'clonedSelectiveData',
	Completed = 'completed',
	Converted = 'converted',
	Reached = 'reached',
	RemoveMember = 'removeMember',
	RemoveFromOrg = 'removedFromOrg',
	PromptPassword = 'promptedResetPassword',
	PasswordReset = 'passwordReset',
	DescriptionUpdated = 'descriptionUpdated',
	RemoveProduct = 'removeProduct',
	AddProduct = 'addProduct',
	AddProductFailed = 'addProductFailed',
	Restored = 'restored',
	RemovedDomain = 'removedDomain',
	Removed = 'removed',
	Reactivated = 'reactivated',
	Subscribed = 'subscribed',
	Unsubscribed = 'unsubscribed',
	UsersUpdated = 'usersUpdated',
	Started = 'started',
	Searched = 'searched',
	SessionReset = 'sessionReset',
	RuleUpdated = 'ruleUpdated',
	Upload = 'Upload',
	OptedIntoExperiments = 'optedIntoExperiments',
	OptedOutOfExperiments = 'optedOutOfExperiments',
	UploadFailure = 'uploadFailure',
	Checked = 'checked',
	Triggered = 'triggered',
	Queried = 'queried',
	Finished = 'finished',
	RemovedUser = 'removedUser',
	Errored = 'errored',
	UserlistDownloaded = 'userList downloaded',
	ManagedAccountsDownloaded = 'managedAccounts downloaded',
	ParseFailure = 'parseFailure',
	Authenticated = 'authenticated',
	Succeeded = 'succeeded',
	Accepted = 'accepted',
	Declined = 'declined',
	DisconnectionFailed = 'disconnectionFailed',
	Recommendation = 'recommendation',
	Redirected = 'redirected',
	Renamed = 'renamed',
	AddedGroupToAgentProfile = 'addedGroupToAgentProfile',
	AddedDefaultAccessToAgentProfile = 'addedDefaultAccessToAgentProfile',
	RemovedGroupToAgent = 'removedGroupToAgent',
	AddedGroupToAgent = 'addedGroupToAgent',
	RemovedAppToAgent = 'removedAppToAgent',
	AddedAppToAgent = 'addedAppToAgent',
	Evaluated = 'evaluated',
	Viewed = 'viewed',
	Failed = 'failed',
	StateChanged = 'stateChanged',
	Redacted = 'redacted',
	DeletedAttachment = 'deletedAttachment',
	MarkedFalsePositive = 'markedFalsePositive',
	Reverted = 'reverted',
}

export const enum ActionSubject {
	Table = 'table',
	Button = 'button',
	Form = 'form',
	Link = 'link',
	AppSwitcherDropdown = 'appSwitcherDropdown',
	AppSwitcherItem = 'appSwitcherItem',
	Organization = 'organization',
	OrganizationSelectorItem = 'organizationSelectorItem',
	BillingSelectorItem = 'billingSelectorItem',
	Border = 'border',
	HelpSelectorItem = 'helpSelectorItem',
	Dialog = 'dialog',
	Datepicker = 'datepicker',
	Field = 'field',
	NavigationItem = 'navigationItem',
	Toggle = 'toggle',
	Checkbox = 'checkbox',
	DropListItem = 'dropListItem',
	DropListTrigger = 'dropListTrigger',
	RadioButton = 'radioButton',
	Radio = 'radio',
	TextField = 'textField',
	Text = 'text',
	Badge = 'badge',
	Dropdown = 'dropdown',
	DropdownItem = 'dropdownItem',
	SelectItem = 'selectItem',
	Error = 'error',
	Chart = 'chart',
	Page = 'page',
	Card = 'card',
	Tooltip = 'tooltip',
	Icon = 'icon',
	NotificationModal = 'notificationModal',
	Notification = 'notification',
	MenuItem = 'menuItem',
	UserPicker = 'userPicker',
	Accordion = 'accordion',
	Tab = 'tab',
	Modal = 'modal',
	Flag = 'flag',
	IphSideBar = 'iphSideBar',
	Input = 'input',
	SearchResult = 'searchResult',
	CallToAction = 'callToAction',
	ResendInvite = 'resendInvite',
	DisimssButton = 'dismissButton',
	EmptyTable = 'emptyTable',
	Row = 'row',
	Option = 'option',
	FilterController = 'filterController',
	Banner = 'banner',
	Spotlight = 'spotlight',
	Content = 'content',
	ContentLink = 'content-link',
	ScrollContainer = 'scrollContainer',
}

export const enum TrackActionSubject {
	Button = 'button',
	CsmPhoneNumberPurchaseFlow = 'csmPhoneNumberPurchaseFlow',
	Page = 'page',
	BulkSelectionLimit = 'bulkSelectionLimit',
	Customer = 'customer',
	DeletedCustomer = 'deletedCustomer',
	Dropdown = 'dropdown',
	Group = 'group',
	GroupName = 'groupname',
	Groups = 'groups',
	Member = 'member',
	Form = 'form',
	Token = 'token',
	User = 'user',
	AddedDefaultAccessToAgentProfile = 'addedDefaultAccessToAgentProfile',
	LandingProduct = 'landingProduct',
	UserList = 'userList',
	UserPassword = 'userPassword',
	UserProvisioning = 'userProvisioning',
	Invitation = 'invitation',
	ProductAccess = 'productAccess',
	Organization = 'organization',
	CustomDomain = 'customDomain',
	AdminApiKey = 'adminApiKey',
	ApiKey = 'userApiKeys',
	Checkbox = 'checkbox',
	UserPermission = 'userPermission',
	SiteAccess = 'siteAccess',
	OrgAccess = 'orgAccess',
	OrgAdmin = 'orgAdmin',
	UserSiteAdminRole = 'userSiteAdminRole',
	SuggestChanges = 'suggestChanges',
	OrgAdminAccess = 'orgAdminAccess',
	Feature = 'feature',
	NewUserAccess = 'newUserAccess',
	InviteUrlLinkToggled = 'inviteUrlLinkToggled',
	InviteUrlLinkRegenerated = 'inviteUrlLinkRegenerated',
	Domain = 'domain',
	MemberApiToken = 'memberApiToken',
	OktaAccount = 'oktaAccount',
	Accounts = 'accounts',
	SessionDuration = 'sessionDuration',
	SiteUrl = 'siteUrl',
	FeatureFlag = 'featureFlag',
	Origin = 'origin', // https://hello.atlassian.net/wiki/spaces/PGT/pages/267613380/Origin+ID+Tracing
	ApprovedDomains = 'approvedDomainsSettings',
	UserInvite = 'userInvitesSettings',
	InviteLinks = 'inviteLinksSettings',
	AccessRequests = 'accessRequestsSettings',
	OrgGSuiteAccount = 'orgGSuiteAccount',
	SiteGSuiteAccount = 'siteGSuiteAccount',
	Sandbox = 'sandbox',
	SandboxResetProducts = 'sandboxResetProducts',
	TwoStepVerification = 'twoStepVerification',
	ThirdPartyAccounts = 'thirdPartyAccounts',
	ReleaseTracks = 'releaseTracks',
	DataSecurityPolicies = 'dataSecurityPolicy',
	IpAllowlist = 'allowlist',
	ExternalSitePolicy = 'externalSitesPolicy',
	MobileDevicePolicy = 'mobileDevicePolicy',
	AuthPolicy = 'authPolicy',
	AuthPolicyType = 'authPolicyType',
	MembersAuthPolicy = 'membersAuthPolicy',
	CmkPolicy = 'cmkPolicy',
	Instance = 'instance',
	DataResidency = 'dataResidency',
	DataResidencyApps = 'dataResidencyApps',
	UserInviteSetting = 'userInviteSetting',
	NotAllowedNoteSetting = 'notAllowedNoteSetting',
	ForgeLogsPreview = 'forgeLogsPreview',
	DisableForgeLogsAccess = 'disableForgeLogsAccess',
	EnableForgeLogsAccess = 'enableForgeLogsAccess',
	ApprovedDomain = 'approvedDomain',
	AccessSetting = 'accessSetting',
	plan = 'plan',
	EmailAddress = 'emailAddress',
	ApplicationTunnel = 'applicationTunnel',
	AuditLogActivitySettings = 'auditLogActivitySettings',
	AuditLogQueryParameters = 'auditLogQueryParameters',
	IdentityProvider = 'identityProvider',
	SamlConfiguration = 'samlConfiguration',
	SamlAssertionEncryption = 'samlAssertionEncryption',
	SlackConnect = 'slackConnect',
	OSyncAccount = 'oSyncAccount',
	ExternalUsers = 'externalUsers',
	ExternalUserPolicy = 'externalUserPolicy',
	ClaimManagedAccounts = 'claimManagedAccounts',
	UnclaimManagedAccounts = 'unclaimManagedAccounts',
	ProductUpdatesFilter = 'productUpdatesFilter',
	ProductUpdatesEmailSubsciption = 'productUpdatesEmailSubsciption',
	MemberSessionToken = 'memberSessionToken',
	MemberOauthToken = 'memberOauthToken',
	SelectiveClaimSetting = 'selectiveClaimSetting',
	SelectiveAccounts = 'selectiveAccounts',
	SelectiveDomain = 'selectiveDomain',
	ActiveUsersByProduct = 'activeUsersByProduct',
	ApiTokenPolicies = 'apiTokenPolicies',
	ProductActivation = 'productActivation',
	ProductRequest = 'productRequest',
	EmailNotification = 'emailNotification',
	ProductSetting = 'productSetting',
	ProductStatus = 'productStatus',
	SearchNoResults = 'searchNoResults',
	SearchDropdownEntry = 'searchDropdownEntry',
	SearchDropdownNoAction = 'searchDropdownNoAction',
	SearchSomeResults = 'searchSomeResults',
	SearchErrorEncountered = 'searchErrorEncountered',
	SiteFilter = 'siteFilter',
	HipaaCompliance = 'hipaaCompliance',
	BaaSignIn = 'baaSignIn',
	AccessTrial = 'accessTrial',
	DataClassificationLevel = 'dataClassificationLevel',
	UserApiTokens = 'userApiTokens',
	DiscoveredProducts = 'discoveredProducts',
	Townsquare = 'townsquare',
	RovoBeta = 'rovoBeta',
	MigrationTask = 'migrationTask',
	MigrationJob = 'migrationJob',
	ServerToCloudTask = 'serverToCloudTask',
	ReportFilter = 'reportFilter',
	OrganizationSetting = 'organizationSetting',
	ZipFile = 'zipFile',
	RovoSearchConnection = 'rovoSearchConnection',
	RovoSearchConnectionDraft = 'rovoSearchConnectionDraft',
	AgpStandardSignup = 'guardStandardTrial',
	AgpPremiumSignup = 'guardPremiumTrial',
	AdminSearchNavigation = 'adminSearchNavigation',
	Eligibility = 'eligibility',
	RovoSearchPin = 'rovoSearchPin',
	RovoSmartlinksSetting = 'rovoSmartlinksSetting',
	RovoSearchPinKeyPhrase = 'rovoSearchPinKeyPhrase',
	RovoGA = 'rovoGA',
	RovoSite = 'rovoSite',
	RovoChatSite = 'rovoChatSite',
	AIRemovedSurvey = 'atlassianIntelligenceRemovedSurvey',
	AIRemovedSurveyVariant = 'submittedAIRemovedSurveyTrackEventVariant',
	AIRemovedSurveyControl = 'submittedAIRemovedSurveyTrackEventControl',
	AdminConfidenceSurvey = 'adminConfidenceSurvey',
	DataContributionSurvey = 'dataContributionSurvey',
	Team = 'team',
	TeamName = 'teamName',
	TeamProfileName = 'teamProfileName',
	RovoConnector = 'rovoConnector',
	RovoConnectorSetup = 'rovoConnectorSetup',
	RelatedArticles = 'relatedArticles',
	ContactSupport = 'contactSupport',
	SearchResults = 'searchResults',
	PlanDraft = 'planDraft',
	Checks = 'checks',
	Export = 'export',
	RemovalUser = 'removalUser',
	GoalsAndProjectsSetting = 'goalsAndProjectsSetting',
	RovoSearchBookmarkImportSubmission = 'rovoSearchBookmarkImportSubmission',
	TWGActionsConfiguration = 'twgActionsConfiguration',
	TWGAppContainer = 'twgAppContainer',
	TWGConnector = 'twgConnector',
	TwgCliAllowDefaultPerms = 'twgCliAllowDefaultPerms',
	TwgCliPermission = 'twgCliPermission',
	RovoBookmarkSuggestion = 'rovoBookmarkSuggestion',
	RovoAccessApp = 'rovoAccessApp',
	ALQLQuery = 'ALQLQuery',
	FreezeWindowCreateFreezeWindow = 'freezeWindowCreateFreezeWindow',
	ProvisionCollection = 'provisionCollection',
	ProvisionServiceCollectionUplift = 'provisionServiceCollectionUplift',
	CollectionTrial = 'collectionTrial',
	ServiceAccountCredential = 'serviceAccountCredential',
	ServiceAccount = 'serviceAccount',
	MCPServer = 'mcpServer',
	MCPServerTool = 'mcpServerTool',
	MCPDomain = 'mcpDomain',
	MCPPermission = 'mcpPermission',
	AtlassianSupportedMCPDomains = 'atlassianSupportedMCPDomains',
	MCPHeadlessAuth = 'mcpHeadlessAuth',
	MCPA2A = 'mcpA2A',
	AppUninstall = 'appUninstall',
	TeamCreateDialog = 'teamCreateDialog',
	TeamInvitation = 'teamInvitation',
	TeamProfileDescription = 'teamProfileDescription',
	TeamMember = 'teamMember',
	JoinRequest = 'joinRequest',
	OverageLimit = 'overageLimit',
	AssignGroupAiAccess = 'assignGroupAiAccess',
	RemoveGroupAiAccess = 'removeGroupAiAccess',
	EnableAutomaticAiAccess = 'enableAutomaticAiAccess',
	DisableAutomaticAiAccess = 'disableAutomaticAiAccess',
	ProvisionStandaloneCollectionApp = 'provisionStandaloneCollectionApp',
	AppActivation = 'appActivation',
	SmartSettingsModalWrapperChecks = 'smartSettingsModalWrapperChecks',
	SmartSettingsRecommendations = 'smartSettingsRecommendations',
	DaNudgeCandidateProducts = 'daNudgeCandidateProducts',
	DaNudgeDomain = 'twcDaNudgeDomainDismissedTapTrait',
	ExportMeterUsageDetails = 'exportMeterUsageDetails',
	ExportRovoUsageDetails = 'exportRovoUsageDetails',
	ExportAgentsDetails = 'exportAgentsDetails',
	ContextualRACollaborators = 'contextualRACollaborators',
	SidepanelProfile = 'sidepanelUserProfile',
	Import = 'import',
	GovernanceManagerPosture = 'governanceManagerPosture',
	GovernanceManagerScope = 'governanceManagerScope',
	GovernanceManagerRefresh = 'governanceManagerRefresh',
	GovernanceManagerM2Error = 'governanceManagerM2Error',
	GovernanceManagerRegression = 'governanceManagerRegression',
	DspControl = 'dspControl',
	DspControlOverride = 'dspControlOverride',
	DspCustomAppControl = 'dspCustomAppControl',
	ClassificationRules = 'classificationRules',
	TwgPlatformCapabilityGlobalSetting = 'twgPlatformCapabilityGlobalSetting',
	AvailableSeatsMonthly = 'available_seats_monthly',
	ShowAvailableSeats = 'show_available_seats',
	SandboxDeploymentEntities = 'sandboxDeploymentEntities',
	ConditionalAccessPolicy = 'conditionalAccessPolicy',
	UnifiedPolicy = 'unifiedPolicy',
	SdpViolationRemediation = 'sdpViolationRemediation',
	CommerceExperienceUrl = 'commerceExperienceUrl',
	TwcUserInterceptEligibility = 'twcUserInterceptEligibility',
	TwcUserInterceptModal = 'twcUserInterceptModal',
	RankRaByMl = 'rankRaByMl',
	TwgMentionSignal = 'twgMentionSignal',
	TwgConfluenceSignal = 'twgConfluenceSignal',
	TwgLoomSignal = 'twgLoomSignal',
	TwgQuerySignal = 'twgQuerySignal',
	CodeContextConnection = 'codeContextConnection',
	TwgJiraSignal = 'twgJiraSignal',
	ActorsList = 'actorsList',
	Workload = 'workload',
	Findings = 'findings',
}

export const enum Source {
	BillEstimate = 'billEstimate',
	BillHistory = 'billHistory',
	BillOverview = 'billOverview',
	DiscoverNewProducts = 'discoverNewProducts',
	ManageSubscriptions = 'manageSubscriptions',
	PaymentDetails = 'paymentDetails',
	AdminSearchDialog = 'adminSearchDialog',
}

export const enum OperationalAction {
	Fetched = 'fetched',
	Exposed = 'exposed',
	Triggered = 'triggered',
	Failed = 'failed',
	Succeeded = 'succeeded',
	Aborted = 'aborted',
	Started = 'started',
	Changed = 'changed',
	Done = 'done',
	Exceeded = 'exceeded',
	Deleted = 'deleted',
	Connected = 'connected',
	Viewed = 'viewed',
	Evaluated = 'evaluated',
	Error = 'error',
	Collected = 'collected',
	TaskAbort = 'taskAbort',
	TaskStart = 'taskStart',
	TaskSuccess = 'taskSuccess',
	TaskFail = 'taskFail',
	Measured = 'measured',
}

export const enum OperationalSubject {
	AuthorizationOutcome = 'authorizationOutcome',
	ConnectorDisconnectionOutcome = 'connectorDisconnectionOutcome',
	OnConnectorCreationFormSubmitOutcome = 'onConnectorCreationFormSubmitOutcome',
	GraphqlResponseSize = 'graphqlResponseSize',
	GraphqlSever = 'graphqlServer',
	Experiment = 'experiment',
	SiteUrlError = 'siteUrlError',
	ParentOrgQuery = 'parentOrgQuery',
	SiteQuery = 'siteQuery',
	DeeplinkedAccessRequest = 'deeplinkedAccessRequest',
	ProductAccess = 'productAccess',
	IdentityProvider = 'identityProvider',
	Circle = 'circle',
	PickLoader = 'pick-loader',
	Feature = 'feature',
	UpgradeToMove = 'upgradeToMove',
	Context = 'context',
	Navigation = 'navigation',
	UserLicense = 'userLicense',
	SlackImportSucceeded = 'slackImportSucceeded',
	InviteUsers = 'inviteUsers',
	ThirdPartyIntegration = 'thirdPartyIntegration',
	ThirdPartyUsers = 'thirdPartyUsers',
	LoadRecaptchaEnterprise = 'loadRecaptchaEnterprise',
	UserInviteLoadRecaptcha = 'userInviteLoadRecaptcha',
	SiteSelectionDropdownError = 'siteSelectionDropdownError',
	FetchNotification = 'fetchNotification',
	MarkNotificationGroupAsRead = 'markNotificationGroupAsRead',
	InvalidAuditLogsUGCPolicy = 'invalidAuditLogsUGCPolicy',
	UgcPolicySave = 'ugcPolicySave',
	PendingAccessRequests = 'pendingAccessRequests',
	OrgPolicies = 'orgPolicies',
	RovoSearchPinFetch = 'rovoSearchPinFetch',
	RovoSearchPinAdd = 'rovoSearchPinAdd',
	RovoSearchPinEdit = 'rovoSearchPinEdit',
	RovoSmartlinksSettingSave = 'rovoSmartlinksSettingSave',
	RovoSearchPinDelete = 'rovoSearchPinDelete',
	RovoAccessAdd = 'rovoAccessAdd',
	RovoAccessRemove = 'rovoAccessRemove',
	GraphQL = 'graphql',
	SearchError = 'searchError',
	RelatedArticlesError = 'relatedArticlesError',
	ArticleFetchError = 'articleFetchError',
	SiteUsersNumber = 'siteUsersNumber',
	ManualUpgradeDataFetch = 'manualUpgradeDataFetch',
	ManualUpgradeBannerRender = 'manualUpgradeBannerRender',
	ReleaseControlsChangeDelay = 'releaseControlsChangeDelay',
	DeferRolloutOptIn = 'deferRolloutOptIn',
	UsersStatsDataFetch = 'usersStatsDataFetch',
	UsersLastActiveDataFetch = 'usersLastActiveDataFetch',
	Experience = 'experience',
	PageLoad = 'pageLoad',
	UpdateUserConsent = 'updateUserConsent',
	ActivitySettingsSync = 'activitySettingsSync',
	JsmGpEndDataFetch = 'jsmGpEndDataFetch',
	UpliftEligibilityCheck = 'upliftEligibilityCheck',
	ServcoUpliftProvisioning = 'servcoUpliftProvisioning',
	ServcoUpliftSiteSelectFailed = 'servcoUpliftSiteSelectFailed',
	ServcoUpliftEmptySiteSelectionTable = 'servcoUpliftEmptySiteSelectionTable',
	SmartSettingsDismissKeySaved = 'smartSettingsDismissKeySaved',
	SmartSettingsModalWrapperRender = 'smartSettingsModalWrapperRender',
	SmartSettingsAccessSettingsUpdate = 'smartSettingsAccessSettingsUpdate',
	SmartSettingsEligibilityFetch = 'smartSettingsEligibilityFetch',
	UnitsEligibilityCheck = 'unitsEligibilityCheck',
	GovernanceManagerFrameworksFetch = 'governanceManagerFrameworksFetch',
	GovernanceManagerSitesMappingsFetch = 'governanceManagerSitesMappingsFetch',
	GovernanceManagerScopeSave = 'governanceManagerScopeSave',
	GovernanceManagerSiteStatusFetch = 'governanceManagerSiteStatusFetch',
	AddCollection = 'addCollection',
	TwcUserInterceptModalOverviewRender = 'twcUserInterceptModalOverviewRender',
	CsmRegulatoryBundlesFetch = 'csmRegulatoryBundlesFetch',
	CsmRegulatoryBundleDelete = 'csmRegulatoryBundleDelete',
	CsmRegulatoryBundleInitialize = 'csmRegulatoryBundleInitialize',
	CsmRegulatoryBundleResume = 'csmRegulatoryBundleResume',
	CsmRegulatoryBundleAvailableCountriesFetch = 'csmRegulatoryBundleAvailableCountriesFetch',
	CsmConsentFetch = 'csmConsentFetch',
	CsmConsentGrant = 'csmConsentGrant',
	CsmPhoneNumberInventoryFetch = 'csmPhoneNumberInventoryFetch',
	CsmPhoneNumberCountriesFetch = 'csmPhoneNumberCountriesFetch',
	CsmAvailablePhoneNumbersSearch = 'csmAvailablePhoneNumbersSearch',
	CsmRegisteredAddressesFetch = 'csmRegisteredAddressesFetch',
	CsmRegisteredAddressCreate = 'csmRegisteredAddressCreate',
	CsmPhoneNumberPurchase = 'csmPhoneNumberPurchase',
	CsmWhatsAppSendersFetch = 'csmWhatsAppSendersFetch',
	CsmWhatsAppWabaLink = 'csmWhatsAppWabaLink',
	CsmWhatsAppWabaUnlink = 'csmWhatsAppWabaUnlink',
	CsmWhatsAppEmbeddedSignup = 'csmWhatsAppEmbeddedSignup',
	CsmWhatsAppNumberAdd = 'csmWhatsAppNumberAdd',
	CsmWhatsAppNumberDelete = 'csmWhatsAppNumberDelete',
	ActorsListLoad = 'actorsListLoad',
	CustomAgentMcpSetting = 'customAgentMcpSetting',
}

// Remember to update capability-event-data.ts with the data portal link for these capabilities
export const enum CapabilitySubject {
	DomainsViewed = 'domainsViewed',
	OrgInsightsViewed = 'orgInsightsViewed',
	RovoInsightsViewed = 'rovoInsightsViewed',
	ManagedAccountDetailsViewed = 'managedAccountDetailsViewed',
	ManagedAccountsViewed = 'managedAccountsViewed',
	AuditLogViewed = 'auditLogViewed',
	ManagedAccountPasswordReset = 'managedAccountPasswordReset',
	SiteAccountsViewed = 'siteAccountsViewed',
	TwoStepVerificationEnabled = 'twoStepVerificationEnabled',
	TwoStepVerificationDisabled = 'twoStepVerificationDisabled',
	SamlConfigured = 'samlConfigured',
	ManagedAccountApiTokenRevoked = 'managedAccountApiTokenRevoked',
	ManagedAccountDeactivated = 'managedAccountDeactivated',
	ManagedAccountDeleted = 'managedAccountDeleted',
	ManagedAccountEdited = 'managedAccountEdited',
	ManagedAccountResetPassword = 'managedAccountResetPassword',
	DomainVerified = 'domainVerified',
	IpAllowlistCreated = 'ipAllowlistCreated',
	IpAllowlistUpdated = 'ipAllowlistUpdated',
	IpAllowlistDeleted = 'ipAllowlistDeleted',
	MobileSecurityCreated = 'mobileSecurityPolicyCreated',
	MobileSecurityUpdated = 'mobileSecurityPolicyUpdated',
	MobileSecurityDeleted = 'mobileSecurityPolicyDeleted',
	DataResidencyViewed = 'dataResidencyViewed',
	DataResidencyChanged = 'dataResidencyChanged',
	DataResidencyCanceled = 'dataResidencyCanceled',
	ReleaseTracksViewed = 'releaseTracksViewed',
	ReleaseTrackChanged = 'releaseTrackChanged',
	ReleaseTracksChangelogsViewed = 'releaseTracksChangelogsViewed',
	SandboxesViewed = 'sandboxesViewed',
	AuthPolicyDeleted = 'authPolicyDeleted',
	AuthPolicyDefaultPolicyChanged = 'authPolicyDefaultPolicyChanged',
	AuthPolicyCreated = 'authPolicyCreated',
	AuthPolicyMembersTabViewed = 'authPolicyMembersTabViewed',
	AuthPoliciesListPageViewed = 'authPoliciesListPageViewed',
	AuthPolicySettingsTabViewed = 'authPolicySettingsTabViewed',
	AuthPolicyAddMembers = 'authPolicyAddMembers',
	AuthPolicyAddMembersWithCSV = 'authPolicyAddMembersWithCSV',
	AuthPolicyUpdated = 'authPolicyUpdated',
	AddProductCreated = 'addProductCreated',
	AuthPoliciesEnabledChecked = 'authPoliciesEnabledChecked',
	AuthPolicyTaskPollingCompleted = 'authPolicyTaskPollingCompleted',
	DiscoveredProductsViewed = 'discoveredProductsViewed',
	AuthPolicyMembersExportInitiated = 'authPolicyMembersExportInitiated',
	ExportDownloaded = 'exportDownloaded',
	AuthPolicyResetSessions = 'authPolicyResetSessions',
	OrgInviteUser = 'orgInviteUser',
	OrgGrantProductAccessUserDetails = 'orgGrantProductAccessUserDetails',
	AuditLogActivitySettingsViewed = 'auditLogActivitySettingsViewed',
	AuditLogActivitySettingsChanged = 'auditLogActivitySettingsChanged',
	IdentityProviderCreated = 'identityProviderCreated',
	OrgGroupDetailsViewed = 'orgGroupDetailsViewed',
	OrgRevokeProductAccessGroupDetails = 'orgRevokeProductAccessGroupDetails',
	OrgRemoveUserFromGroup = 'orgRemoveUserFromGroup',
	OrgAssignPlatformRole = 'orgAssignPlatformRole',
	OrgAddUserToGroupModal = 'orgAddUserToGroupModal',
	GroupListViewed = 'groupListViewed',
	OrgGrantProductAccessGroupDetails = 'orgGrantProductAccessGroupDetails',
	DirectoryGrantProductAccessGroupDetails = 'directoryGrantProductAccessGroupDetails',
	IdentityProviderDeleted = 'identityProviderDeleted',
	OrgProductDetailsViewed = 'orgProductDetailsViewed',
	OrgUserListViewed = 'orgUserListViewed',
	OrgRevokeProductAccessUserDetails = 'orgRevokeProductAccessUserDetails',
	OrgRevokePlatformRole = 'orgRevokePlatformRole',
	OrgCreateGroup = 'orgCreateGroup',
	UserDetailsViewed = 'userDetailsViewed',
	OrgDeleteGroup = 'orgDeleteGroup',
	ExternalUserExportInitiated = 'externalUsersExportInitiated',
	ExternalUserPolicyCreated = 'externalUserPolicyCreated',
	ExternalUserPolicyUpdated = 'externalUserPolicyUpdated',
	ExternalUserApiTokenPolicyUpdated = 'externalUserApiTokenPolicyUpdated',
	OrgImpersonateUser = 'orgImpersonateUser',
	OrgRemoveUser = 'orgRemoveUser',
	AddUserToGroupDetails = 'addUserToGroupDetails',
	OrgActivateUser = 'orgActivateUser',
	OrgDeactivateUser = 'orgDeactivateUser',
	OrgUpdateGroupAsDefault = 'orgUpdateGroupAsDefault',
	LicenseUtilizationViewed = 'licenseUtilizationViewed',
	OrgPromptResetPassword = 'orgPromptResetPassword',
	OrgAddGroupToProductDetails = 'orgAddGroupToProductDetails',
	OrgSuggestChangesToUserDetails = 'orgSuggestChangesToUserDetails',
	ContactsViewed = 'contactsViewed',
	ProductUpdatesViewed = 'productUpdatesViewed',
	ProductUpdateDetailsViewed = 'productUpdateDetailsViewed',
	ProductUpdatesEmailSubscribe = 'productUpdatesEmailSubscribe',
	ProductUpdatesReleaseDatesViewed = 'productUpdatesReleaseDatesViewed',
	UserConnectedAppsViewed = 'singleAppListingUserConnectedAppsViewed',
	UserConnectedAppsDetailsPageViewed = 'userConnectedAppsDetailsPageViewed',
	UserConnectedAppsUpdateConsentScreen = 'userConnectedAppUpdateConsentScreen',
	ManagedAccountSessionTokenRevoked = 'managedAccountSessionTokenRevoked',
	WorkspacesViewed = 'workspacesViewed',
	OpsgenieJSMMerged = 'opsgenieJSMMerged',
	OrgBillingPreviewViewed = 'orgBillingPreviewViewed',
	OrgBillingPreviewGroupedBySiteViewed = 'orgBillingPreviewGroupedBySiteViewed',
	OrgBillingPreviewV2 = 'orgBillingPreviewV2',
	SiteBillingPreviewV2 = 'siteBillingPreviewV2',
	SiteBillingPreviewViewed = 'siteBillingPreviewViewed',
	apiTokenPolicyUpdated = 'apiTokenPolicyUpdated',
	FeatureGatesClientInitialized = 'featureGatesClientInitialized',
	ExternalUserPolicySessionReset = 'externalUserPolicySessionReset',
	ExternalUserPolicySessionDurationUpdated = 'externalUserPolicySessionDurationUpdated',
	DataSecurityPoliciesPublicLinksRuleUpdated = 'dataSecurityPoliciesPublicLinksRuleUpdated',
	rovoActivatedSitesViewed = 'rovoActivatedSitesViewed',
	rovoConnectorsTableLoaded = 'rovoConnectorsTableLoaded',
	thirdPartyConnectorViewed = 'thirdPartyConnectorViewed',
	ExperimentControlsToggleOptIn = 'ExperimentControlsToggleOptIn',
	ExperimentControlsPageViewed = 'ExperimentControlsPageViewed',
	ALQLQueryCreated = 'ALQLQueryCreated',
	AuditLogBasicQuery = 'AuditLogBasicQuery',
	AuditLogAsyncQueryListQuery = 'AuditLogAsyncQueryListQuery',
	AuditLogActorFilterQueryUUL = 'AuditLogActorFilterQueryUUL',
	AuditLogActorFilterQuery = 'AuditLogActorFilterQuery',
	AuditLogMultipleWebhooksAdd = 'AuditLogMultipleWebhooksAdd',
	AuditLogMultipleWebhooksEdit = 'AuditLogMultipleWebhooksEdit',
	AppAuditLogEventExclusionSettingsUpdated = 'AppAuditLogEventExclusionSettingsUpdated',
	DynamicBannerQuery = 'DynamicBannerQuery',
	ScheduleRestore = 'ScheduleRestore',
	StartRestore = 'StartRestore',
	ImportStorage = 'ImportStorage',
	IdleConfluencesQuery = 'IdleConfluencesQuery',
	SmartSettingsEligibilityCheck = 'smartSettingsEligibilityCheck',
}

export interface DataType {
	action: Action;
	actionSubject: ActionSubject;
	actionSubjectId: string;
	source: string;
}

// Extracted types from FeatureEvents below to typecheck analytics function in rendered component as needed
export type FeatureEventUi = (
	attributes?: Record<string, any>,
	data?: Partial<DataType>,
) => UIEvent;

export interface FeatureEvents<
	TScreenKeys extends string,
	TUiKeys extends string,
	TTrackKeys extends string,
	TOperationalKeys extends string,
> {
	confluenceSpec: string | string[];
	screen: Record<TScreenKeys, (attributes?: Record<string, any>) => ScreenEvent>;
	ui: Record<TUiKeys, FeatureEventUi>;
	track: Record<TTrackKeys, (attributes?: Record<string, any>) => TrackEvent>;
	operational: Record<TOperationalKeys, (attributes?: Record<string, any>) => OperationalEvent>;
}

export interface UIEvent {
	cloudId?: string;
	orgId?: string;
	tenantId?: string;
	tenantIdType?: 'orgId' | 'cloudId';
	data: UIData;
	dataPortalLink?: string;
}

export interface UFOEvent {
	action: OperationalAction;
	actionSubject: OperationalSubject | CapabilitySubject;
	actionSubjectId?: string;
	source: string;
	attributes?: Record<string, any>;
	tags?: object;
	eventType?: string;
}

export interface ScreenEvent {
	cloudId?: string;
	orgId?: string;
	data: ScreenData;
	dataPortalLink?: string;
}

export interface TrackEvent {
	cloudId?: string;
	orgId?: string;
	data: TrackData;
	dataPortalLink?: string;
}

export interface OperationalEvent {
	cloudId?: string;
	orgId?: string;
	data: OperationalData;
	dataPortalLink?: string | string[];
	tags?: string[];
}

export type UIData = Readonly<{
	action: Action;
	actionSubject: ActionSubject;
	actionSubjectId?: string;
	source: string;
	objectType?: string;
	objectId?: string;
	object?: string;
	container?: string;
	attributes?: Record<string, any>;
	tags?: object;
	product?: string;
	eventType?: string;
}>;

export type ScreenData = Readonly<{
	name: string;
	attributes?: Record<string, any>;
	tags?: object;
	product?: string;
	platform?: string;
}>;

export type TrackData = Readonly<{
	source: string;
	action: TrackAction | string;
	actionSubject: TrackActionSubject;
	actionSubjectId?: string;
	attributes?: Record<string, any>;
	tags?: object;
}>;

export interface UFOOperationalEvent {
	action: OperationalAction;
	actionSubject: OperationalSubject | CapabilitySubject;
	eventType?: string;
	source: string;
	tags?: string[];
	attributes?: Record<string, any>;
}

export interface OperationalData {
	action: OperationalAction;
	actionSubject: OperationalSubject | CapabilitySubject;
	actionSubjectId?: string;
	source: string;
	attributes?: Record<string, any>;
	tags?: object;
}

export type EngagekitEvent = Readonly<{
	payload: TrackData;
}>;
